import { CampaignStatus } from '@@types/api.types';
import { Badge, type BadgeProps } from '@components/ui/badge';
import type { FC } from 'react';

const STATUS_VARIANT: Record<CampaignStatus, BadgeProps['variant']> = {
  [CampaignStatus.ACTIVE]: 'status-approved',
  [CampaignStatus.ARCHIVED]: 'status-archived',
  [CampaignStatus.DRAFT]: 'status-draft',
  [CampaignStatus.HISTORICAL]: 'status-historical',
};

const STATUS_LABEL: Record<CampaignStatus, string> = {
  [CampaignStatus.ACTIVE]: 'Active',
  [CampaignStatus.ARCHIVED]: 'Archived',
  [CampaignStatus.DRAFT]: 'Draft',
  [CampaignStatus.HISTORICAL]: 'Historical',
};

type CampaignStatusBadgeProps = {
  muted?: boolean;
  size?: BadgeProps['size'];
  status: CampaignStatus;
};

/**
 * Standardized campaign lifecycle badge — lives next to `StudyStatusBadge` and
 * `ClassificationBadge` so every campaign status render in the app uses the
 * same `status-*` palette. Set `muted` to render an outline-only variant for
 * filter chip toggles.
 */
export const CampaignStatusBadge: FC<CampaignStatusBadgeProps> = (props) => {
  const { muted = false, size = 'xs', status } = props;
  return (
    <Badge
      size={size}
      variant={muted ? 'outline' : STATUS_VARIANT[status]}
    >
      {STATUS_LABEL[status]}
    </Badge>
  );
};
